

import getVersion from '../version';
import * as positionCodecs from '../map/position-codecs';


var InspectorStats = function(inspector) {
    this.inspector = inspector;
    this.core = inspector.core;
};


InspectorStats.prototype.init = function() {
    var inspector = this.inspector;
    inspector.addStyle(
        '#vts-stats-panel {'
            + 'font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;'
            + 'color: #000000;'
            + 'display: none;'
            + 'padding:15px;'
            + 'width: 325px;'
            + 'font-size: 13px;'
            + 'position: absolute;'
            + 'right: 10px;'
            + 'top: 10px;'
            + 'cursor: default;'
            + 'background-color: rgba(255,255,255,0.95);'
            + 'border-radius: 5px;'
            + 'border: solid 1px #ccc;'
            + 'text-align: left;'
            + 'z-index: 7;'
            + 'padding: 10px;'
        + '}'

        + '#vts-stats-panel-info {'
            + 'margin-top: 5px;'
            + 'margin-bottom: 3px;'
            + 'overflow: hidden;'
        + '}'

        + '#vts-stats-panel-info table {'
            + 'text-align: left;'
            + 'font-size: 12px;'
        + '}'

        + '#vts-stats-panel-info table td {'
            + 'vertical-align: top;'
        + '}'

        + '#vts-stats-panel-pos {'
            + 'width: 100%;'
        + '}'
    );

    this.element = document.createElement('div');
    this.element.id = 'vts-stats-panel';
    this.element.innerHTML =
        '<span id="vts-stats-panel-title">Version: ' + getVersion() + '</h3>'+
        '<p id="vts-stats-panel-info"></p>'+
        '<input id="vts-stats-panel-pos" type="text">';

    this.core.element.appendChild(this.element);
    this.infoElement = document.getElementById('vts-stats-panel-info');
    this.posElement = document.getElementById('vts-stats-panel-pos');

    this.element.addEventListener('mouseup', inspector.doNothing.bind(this), true);
    this.element.addEventListener('mousedown', inspector.doNothing.bind(this), true);
    this.element.addEventListener('mousewheel', inspector.doNothing.bind(this), false);
    this.element.addEventListener('dblclick', inspector.doNothing.bind(this), false);

    this.panelVisible = false;
};


InspectorStats.prototype.showPanel = function() {
    this.element.style.display = 'block';
    this.panelVisible = true;

    var map = this.core.getMap();
    if (map && this.savedProfileGpu == null) {
        this.savedProfileGpu = map.config.mapProfileGpu;
        map.config.mapProfileGpu = true;
    }

    this.pumpRedraw();
};


// While the panel is open, keep the map drawing each frame so the frame
// profiler has fresh samples to show; the loop stops once it closes.
InspectorStats.prototype.pumpRedraw = function() {
    if (!this.panelVisible) {
        return;
    }

    this.core.markDirty();

    var self = this;
    requestAnimationFrame(function() { self.pumpRedraw(); });
};


InspectorStats.prototype.hidePanel = function() {
    this.element.style.display = 'none';
    this.panelVisible = false;

    var map = this.core.getMap();
    if (map && this.savedProfileGpu != null) {
        map.config.mapProfileGpu = this.savedProfileGpu;
        this.savedProfileGpu = null;
    }
};


InspectorStats.prototype.switchPanel = function() {
    if (this.panelVisible) {
        this.hidePanel();
    } else {
        this.showPanel();
    }
};


InspectorStats.prototype.updateStatsPanel = function(stats) {
    if (!this.infoElement || !this.panelVisible) {
        return;
    }
    var inspector = this.inspector;
    
    var fp = stats.frameProfile;
    var idle = (fp && fp.ageMs > 1000)
        ? ' (idle ' + (fp.ageMs / 1000).toFixed(1) + 's)' : '';
    var rafFps = (fp && fp.rafFps) ? fp.rafFps.toFixed(1) : 'n/a';
    var fpsText = fp
        ? ('FPS limit: ' + (fp.limitFps ? Math.round(fp.limitFps) : 'n/a')
                + idle + '<br/>'
            + 'RAF cadence: ' + rafFps + ' fps<br/>'
            + 'CPU frame: ' + fp.cpuMs.median.toFixed(2) + ' ms<br/>'
            + (fp.gpuMs.available
                ? 'GPU frame: ' + fp.gpuMs.median.toFixed(2) + ' ms<br/>'
                : ''))
        : 'FPS limit: n/a<br/>';

    var text2 =
            // Group 1 - render performance.
            fpsText +
            'Draw calls: ' + (fp ? fp.drawCalls : 0) + '<br/>' +
            'Texture binds: ' + (fp ? fp.textureBinds : 0) + '<br/>' +
            'FBO switches: ' + (fp ? fp.fboSwitches : 0) + '<br/><br/>' +

            // Group 2 - caches.
            'GPU Cache: ' + Math.round(stats.gpuUsed/(1024*1024))
                + ' / ' + Math.round(stats.gpuBudget/(1024*1024))
                + ' MB<br/>' +
            ' - textures: ' + Math.round(stats.gpuTextures/(1024*1024))
                + ' MB<br/>' +
            ' - meshes: ' + Math.round(stats.gpuMeshes/(1024*1024))
                + ' MB<br/>' +
            ' - geodata: ' + Math.round(stats.gpuGeodata/(1024*1024))
                + ' MB<br/>' +
            'CPU Cache: ' + Math.round(stats.resourcesUsed/(1024*1024))
                + ' / ' + Math.round(stats.resourcesBudget/(1024*1024))
                + ' MB<br/>' +
            'Metatile Cache: ' + Math.round(stats.metaUsed/(1024*1024))
                + ' / ' + Math.round(stats.metaBudget/(1024*1024))
                + ' MB<br/>' +
            'Elevation Store: ' + Math.round(stats.elevationUsed/(1024*1024))
                + ' / ' + Math.round(stats.elevationBudget/(1024*1024))
                + ' MB<br/><br/>' +

            // Group 3 - this frame's render footprint.
            'Render resources: '
                + Math.round(stats.gpuRenderUsed/(1024*1024)) + ' MB<br/>' +
            'Topdown: ' + Math.round(stats.gpuNeeded/(1024*1024))
                + ' MB<br/>' +
            'Polygons: ' + (stats.drawnFaces) + '<br/><br/>' +
            'Terrain Height: ' + (stats.heightTerrain.toFixed(2)) + '<br/>' +
            '- float: ' + (stats.heightDelta.toFixed(2)) + '<br/>' +
            '<br/>' +
            'Loaded/Errors: ' + (stats.loadedCount) + ' / ' + (stats.loadErrorCount) + '<br/>' +
            'Load time: ' + ((stats.loadLast - stats.loadFirst)*0.001).toFixed(2) + 's <br/>';

    var renderer = this.core.renderer;

    if (renderer) {
        text2 += '<br/>Render jobs: ' + renderer.totalJobs + '<br/>' +
                 'Drawn jobs: ' + renderer.drawnJobs + '<br/>' +
                 'Jobs total time: ' +  Math.round((renderer.jobsTimer2 - renderer.jobsTimer1)*1000) + '<br/>' +
                 'Jobs reduce time: ' + Math.round((renderer.jobsTimer4)*1000) + '<br/>';

    }

    if (stats.debugStr) {
        text2 += stats.debugStr + '<br/>';        
    }

    var text3 = '';

    var map = this.core.getMap();

    if (map) {
        text3 += 'ReduceMode: ' +'<br/>'+ map.config.mapFeaturesReduceMode +'<br/>'+
                 'ReduceParams: ' +'<br/>'+ JSON.stringify(map.config.mapFeaturesReduceParams) +'<br/><br/>';

        if (map.outerMap.overrides.meshStats) {
            text3 += 'TexelsPerPoly: ' + (stats.meshesUVArea / Math.max(1,stats.meshesFaces)).toFixed(2) +'<br/><br/>';
        }

        const verticalExaggeration = map.outerMap.verticalExaggeration;

        if (verticalExaggeration.scaleRamp) {
            const viewExtent = map.outerMap.selectionCamera.viewExtent;
            text2 += '<br/>VE scale factor: '
                + verticalExaggeration.scaleFactor(viewExtent).toFixed(2)
                + '<br/>';
            text2 += 'Map scale : 1 : ' +
                Math.round(verticalExaggeration.scaleDenominator(
                    viewExtent)).toLocaleString() + '<br/>';
        }
    }

    text3 += 'Metatiles: ' + (stats.processedMetatiles) +'<br/>'+
             'Metanodes: ' + (stats.processedNodes) + ' / ' + (stats.usedNodes) + '<br/>'+
             'GeodataTiles: ' + (stats.drawnGeodataTiles) + '<br/>';

    if (stats.octoNodes) {
        text3 += 'OctoNodes: ' + (stats.octoNodes) +'<br/>'+
                 'OctoNodesMem: ' + Math.round(stats.octoNodesMemSize/(1024*1024)) + ' MB<br/>';
    }

    text3 += '<br/>';

    if (renderer) {
        text3 += 'Nodes: ' + (renderer.drawnNodes) +'<br/><br/>';
    }

    text3 += 'Tiles (attempted):' +'<br/>';

    for (var i =0, li = stats.renderedLods.length; i < li; i++) {
        if (stats.renderedLods[i]) {
            text3 += 'LOD ' + i + ': ' + (stats.renderedLods[i]) +'<br/>';
        }
    }

    text3 += 'Total: ' + (stats.drawnTiles) +'<br/>';

    text3 += '<br/>Tiles (by surface):' +'<br/>';

    var surfaceIds = Object.keys(stats.renderedSurfaces).sort();

    for (var s = 0, ls = surfaceIds.length; s < ls; s++) {
        text3 += surfaceIds[s] + ': ' +
            (stats.renderedSurfaces[surfaceIds[s]]) +'<br/>';
    }

    text3 += 'Total: ' + (stats.drawnTiles) +'<br/>';

    if (renderer) {
        var renderTarget = renderer.gpu.currentRenderTarget;
        var apparentSize = renderTarget.apparentSize;
        var viewportSize = renderTarget.viewportSize;
        var cssScale = renderTarget.cssScale;
        var formatSize = function(size) {
            return Math.round(size[0]) + 'x' + Math.round(size[1]);
        };
        var formatScale = function(size) {
            return size[0].toFixed(2) + 'x' + size[1].toFixed(2);
        };

        text3 += '<br/>Rendering sizes:<br/>' +
                 ' - apparent: ' + formatSize(apparentSize) + '<br/>' +
                 ' - viewport: ' + formatSize(viewportSize) + '<br/>' +
                 ' - css scale: ' + (cssScale ? formatScale(cssScale) : 'n/a') + '<br/>' +
                 ' - DPR: ' + (renderTarget.devicePixelRatio ?? window.devicePixelRatio ?? 1).toFixed(2) +
                 '<br/>';
    }


    var text = '<table style="width:325px"><tr><td>' + text2
        + '</td><td>' + text3 + '</td></tr></table>';

    this.infoElement.innerHTML = text;

    if (map) {
        var s = positionCodecs.vts.encodeString(
            map.outerMap.camera.definition);

        if (this.posElement.value != s) {
            this.posElement.value = s;
        }
    }
};


export default InspectorStats;
